import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const PaymentFinal = () => {
  const [payID, setPayID] = useState();
  const [showCVV, setShowCVV] = useState(false);

  const productDetailsState = useSelector((state) => state.productDetails);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const paymentOption = [
    {
      id: 1,
      name: "Authorize your card to send exchange immediately",
    },
    {
      id: 2,
      name: "Send my exchange after I return",
    },
  ];
  return (
    <main className="p22 choose">
      <div className="saara__container">
        <div className="saara-justify-content-center row__title">
          <div>
            <h1 class="p22__title saara-title">Exchange option</h1>
          </div>
        </div>
        <div className="saara-justify-content-center p22__row">
          <div>
            <form className="p22__wrapper ">
              <div className="p22__inner">
                <div className="bank_card">
                  <div className="bank_card__block block__number">
                    <span className="bank_card__name">Card number</span>
                    <input
                      type="text"
                      maxlength="25"
                      size="25"
                      className="bank_card__number bank_card__input"
                      inputmode="numeric"
                    />
                  </div>
                  <div className="bank_card__block block__date">
                    <span className="bank_card__name">Expire date</span>
                    <input
                      type="text"
                      maxlength="5"
                      size="5"
                      placeholder="−−/−−"
                      className="bank_card__date bank_card__input"
                      inputmode="numeric"
                    />
                  </div>
                  <div className="bank_card__block block__cvv">
                    <span className="bank_card__name">CVV</span>
                    <input
                      type={`${showCVV ? "text" : "password"}`}
                      maxlength="3"
                      size="3"
                      className="bank_card__cvv bank_card__input"
                      inputmode="numeric"
                    />

                    <img
                      onClick={() => {
                        setShowCVV(!showCVV);
                      }}
                      className="bank_card__icon"
                      src={`${
                        showCVV
                          ? "assets/svg/eye.svg"
                          : "assets/svg/crossed-eye.svg"
                      }`}
                      width="18"
                      height="18"
                      alt="hide"
                    />
                  </div>
                </div>
                <div className="p22__choose">
                  {paymentOption.map((item) => {
                    return (
                      <div
                        className={`choose__card ${
                          payID === item.id ? "active" : ""
                        }`}
                        key={item.id}
                        onClick={() => {
                          setPayID(item.id);
                        }}
                      >
                        <h2 className="choose__card_title">{item.name}</h2>
                        <label className="choose__label">
                          <input
                            className="choose__input"
                            type="radio"
                            name="choose"
                          />
                          <span className="choose__input_circle"></span>
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
              <Link to="/ExchangeSubmitted">
                <button type="button" className="saara__btn btn__continue">
                  {storeConfigState?.themeConfig?.continue_button_label}
                </button>
              </Link>
            </form>
          </div>
          <div>
            <div className="exchange__card">
              <span className="exchange__card_status status__new">
                {
                  storeConfigState?.themeConfig
                    ?.exchange_review_new_product_tag_label
                }
              </span>
              <div className="exchange__picture">
                <img src="assets/wear2.webp" alt="" className="exchange__img" />
              </div>
              <div className="exhange__text">
                <p className="exchange__card_desc">
                  classNameic fit plaid oxford T&#8209;shirt
                </p>
                <div className="exchange__card_info">
                  <p>
                    Price:{" "}
                    <span className="exchange__card_price">
                      {productDetailsState.currency}55
                    </span>{" "}
                  </p>
                  <span className="exchange__card_separator">/</span>
                  <p>
                    Size: <span className="exchange__card_size">L</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="exchange__card ">
              <span className="exchange__card_status status__old">
                {
                  storeConfigState?.themeConfig
                    ?.exchange_review_old_product_tag_label
                }
              </span>
              <div className="exchange__picture">
                <img src="assets/wear1.webp" alt="" className="exchange__img" />
              </div>
              <div className="exhange__text">
                <p className="exchange__card_desc">
                  classNameic fit plaid oxford T&#8209;shirt
                </p>
                <div className="exchange__card_info">
                  <p>
                    Price:{" "}
                    <span className="exchange__card_price">
                      {productDetailsState.currency}55
                    </span>{" "}
                  </p>
                  <span className="exchange__card_separator">/</span>
                  <p>
                    Size: <span className="exchange__card_size">L</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
